<script>
    import Icono from "../UI/Icono.svelte";
    export let tipo;

    export let tamano = 'grande';
</script>

<style>
    .icono {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.8em;
        color: #fff;
        background: var(--color);
        padding: .4em;
        border-radius: var(--radio-global);
        margin-right: .5em;
        transition: .3s;
    }

    .pequeno {
        font-size: .8em;
    }
</style>

<div class="icono {tamano}" style="--color: {tipo.color}">
    <Icono>{tipo.duracion ? 'timer' : 'timer_off'}</Icono>
</div>